import classNames from 'classnames';
import React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { DiscountVariant } from '../../Blocks/DiscountVariant.csharp';
import { InfoLabelProps } from './InfoLabelProps';

export const NewProductInfoLabel: React.FunctionComponent<InfoLabelProps> = (props) => {
    return (
        <div className={classNames('Label', 'Label__ProductInfoLabel', props.variant === DiscountVariant.Small)}>
            {getTranslation(keys['enum.infoBanner.newItem'])}
        </div>
    );
};
